import { chartColor } from '@/shared/lib/chart-theme';
import { useThemeStore } from '@/shared/lib/theme';
import { StyleProvider } from '@ant-design/cssinjs';
import { ConfigProvider, theme as antdTheme } from 'antd';
import { Fragment, type FC, type PropsWithChildren } from 'react';

export const AntdProvider: FC<PropsWithChildren> = ({ children }) => {
  // antd owns its own component internals, so the CSS token swap in dark.css
  // can't reach them — it needs to be told separately.
  const isDark = useThemeStore((state) => state.theme === 'dark');

  return (
    <StyleProvider layer>
      <ConfigProvider
        theme={{
          algorithm: isDark
            ? antdTheme.darkAlgorithm
            : antdTheme.defaultAlgorithm,
          token: {
            colorPrimary: chartColor('--color-primary-5'),
            borderRadius: 2,
          },
        }}
      >
        {/*
         * Remount the tree when the theme flips. Chart.js draws to a canvas, so
         * its colors are resolved once (via `chartColor`) and then baked into
         * pixels — a CSS variable change is invisible to it. Charts are spread
         * across dozens of components, so keying here beats threading a
         * subscription through every one of them; toggling is rare enough that
         * losing transient component state is a fair trade.
         */}
        <Fragment key={isDark ? 'dark' : 'light'}>{children}</Fragment>
      </ConfigProvider>
    </StyleProvider>
  );
};
